import React from 'react';
import { Grid, Card, CardContent, Typography, Avatar, Divider, Box, CssBaseline, Container, CardMedia, Stack, Button, AppBar } from '@mui/material';
import { Link } from 'react-router-dom';
import HorizontalImageCarousel from 'components/HorizontalImageCarousel';
import BehindScenesTimeline from 'components/BehindScenesTimeline';
import MasonryScenes from 'components/MasonryScenes';
import Footer from 'components/layout/main/Footer';

const EcatlProfile = () => {

  return (
    <>
     <Container maxWidth={false} disableGutters>
      {/* Sección: Perfil Básico */}
      <CssBaseline />

      <Box elevation={0} sx={{ borderRadius: 0, position: 'relative' }}>
        <Box
          component="video"
          src={
            "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fvideo%2Fmushahas.mp4?alt=media&token=f51083cd-a852-41c9-8a8f-4c8aee63b3dd"
          }
          sx={{ height: '100vh', objectFit: 'cover', width: '100%' }}
          controls = {false}
          autoPlay
          muted
          loop
        />
        {/* Overlay content */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'end',
            alignItems: 'start',
            color: '#fff',
            textAlign: 'start',
            p: 10,
          }}
        >
          
        </Box>
        {/* Brand logo at top-left */}
        <Box
          sx={{
            position: 'absolute',
            top: 16,
            left: 16,
            zIndex: 2,
          }}
        >
          <Link to="/home" style={{ display: 'inline-block' }}>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/leidenfrost.svg?alt=media&token=aa8b35e7-10dc-4f45-9530-63fef6768eca" // reemplaza con tu ruta real
              alt="Brand Logo"
              style={{ width: 140, height: 'auto',
              cursor: 'pointer', objectFit: 'contain' }}
            />
          </Link>
        </Box>
      </Box>

      <MasonryScenes photos = {[
        { src: "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fbehind_scenes%2FScreenshot%202025-09-12%20at%202.38.07%E2%80%AFp.m..png?alt=media&token=5a8bde48-f1bd-4142-8f1b-a9ba1b08ae43", title: "Setup" },
        { src: "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fbehind_scenes%2FScreenshot%202025-09-12%20at%201.37.14%E2%80%AFp.m..png?alt=media&token=8bf11987-f645-430e-8e2d-c31b8cec08a1", title: "Lighting" },
        { src: "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fbehind_scenes%2FScreenshot%202025-09-12%20at%201.37.44%E2%80%AFp.m..png?alt=media&token=e9c0e9bb-0fda-4d8f-9926-e5bbd1809e76", title: "Editing" },
        { src: "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fbehind_scenes%2FScreenshot%202025-09-12%20at%201.34.00%E2%80%AFp.m..png?alt=media&token=c0041767-1fa7-4bad-9884-ac6300bcf48d", title: "Editing" },
        { src: "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fbehind_scenes%2FScreenshot%202025-09-12%20at%202.37.25%E2%80%AFp.m..png?alt=media&token=49c3dee4-3a0e-4f2c-85ec-5603b7bdebcb", title: "Editing" },
        { src: "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fbehind_scenes%2FScreenshot%202025-09-12%20at%202.37.41%E2%80%AFp.m..png?alt=media&token=2340a7c5-c3e5-4086-8d5f-1b83433a9181", title: "Editing" },
        { src: "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fbehind_scenes%2Fbehind_scenes_1.jpeg?alt=media&token=3f087584-79bb-40bc-9015-9f188c9cb0b4", title: "Editing" },
        { src: "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fbehind_scenes%2Fbehind_scenes_2.jpeg?alt=media&token=3035e861-7051-47df-9fcf-5bbcdc8682da", title: "Editing" },
        { src: "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fbehind_scenes%2Fbehind_scenes_3.jpeg?alt=media&token=d333dcad-b91e-4522-91c5-5efcaf858f46", title: "Editing" },
        { src: "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fbehind_scenes%2Fbehind_scenes_5.jpg?alt=media&token=02353943-aec0-49be-abf9-7660b374de24", title: "Editing" },
        ]} 
        title={"Behind Scenes"}
      />

      <Container
        maxWidth={false}
        sx={{
          pt: 2,
          pb: 2,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundColor: "#e5383b",
        }}
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
          component="main"
        >
          <Grid item xs={12} sm={12} md={12}>
            <Typography
              variant="h1"
              fontWeight="bold"
              gutterBottom
              align="center"
              sx={{
                mb: 2,
                color: "#fff",
                fontSize: { xs: 60, sm: 120, md: 200 },
                animation: "vibrate 0.3s infinite",
                "@keyframes vibrate": {
                  "0%": { transform: "translate(0)" },
                  "20%": { transform: "translate(-1px, 1px)" },
                  "40%": { transform: "translate(-1px, -1px)" },
                  "60%": { transform: "translate(1px, 1px)" },
                  "80%": { transform: "translate(1px, -1px)" },
                  "100%": { transform: "translate(0)" },
                },
              }}
            >
              Fashion passes, style remains.
            </Typography>
          </Grid>
        </Grid>
      </Container>


      <HorizontalImageCarousel images = {[
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl1.jpeg?alt=media&token=e6883e87-42f1-447a-a808-027cb689effc",
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl2.jpeg?alt=media&token=a12809a0-b150-4493-bc81-db5ac8138bae",
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl3.jpeg?alt=media&token=218c1933-5b3d-4c04-b4ff-dc75ec4bcf51",
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl4.jpeg?alt=media&token=b069c22e-27b1-45da-ab41-7e52f0c35709",
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl5.jpeg?alt=media&token=7086677d-2325-4017-bbc2-1d699e0012f2",
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl6.jpeg?alt=media&token=2a531306-356e-4255-9e8a-80e4fc306566",
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl7.jpeg?alt=media&token=146ac31b-9b5b-47ae-a1f4-bb07b5db899f",
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl8.jpeg?alt=media&token=46e13fd8-be46-4882-9b56-b8f1e1af8655",
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl%2Fcarousel%2Fcarousel_1.jpeg?alt=media&token=dbc0974d-1c86-4159-a8c4-aa2d85cc32b2",
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl%2Fcarousel%2Fcarousel_2.jpeg?alt=media&token=ffadc909-1488-4f6f-9381-358eca847fee",
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl%2Fcarousel%2Fcarousel_3.jpeg?alt=media&token=b7a7b23c-9433-4f76-97b9-ed7b208f2691",
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl%2Fcarousel%2Fcarousel_4.jpeg?alt=media&token=10112671-b985-462c-acab-cb084371996e",
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl%2Fcarousel%2Fcarousel_5.jpeg?alt=media&token=96d09c41-23fc-45ff-8191-c50d5d90e922",
          "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl%2Fcarousel%2Fcarousel_6.jpg?alt=media&token=8ea1b3ba-069c-4cc7-8ca9-be4bfa9c5990",
        ]} title={"Proyectos"}/>

      {/*<BehindScenesTimeline></BehindScenesTimeline>*/}

      <Container maxWidth={'xl'} sx={{
        pt:2,
        pb:24,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        }}
      >
        <Grid container spacing={2} alignItems="center" justifyContent="center" component="main">
          <Grid item xs={12} sm={12} md={6} >
            <Stack spacing={3}>
                <Typography variant="h4" align="left" color="white" fontWeight="bold">
                Unimos experiencia en tecnología, innovación y producción audiovisual, ofreciendo soluciones creativas que elevan el valor y la presencia de cada marca.
                </Typography>
                <Divider style={{ background: 'white' }}/>
                <Typography variant="body1" align="left" color="white">
                Somos un grupo de asociados expertos en tecnologia, inovación y video.
                </Typography>
              </Stack>
          </Grid>
          <Grid item xs={12} sm={12} md={3} >
          </Grid>
          <Grid item xs={12} sm={12} md={3} >
              <Link to="/"> 
              <Button variant="special">
                Conocer más
              </Button>
              </Link>
          </Grid>
        </Grid>
      </Container>
      
    </Container>
    <Footer maxWidth={'xl'}></Footer>
    </>
  );
};

export default EcatlProfile;
